//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import axios from 'axios';
import Item from './Item.vue';
import PortfolioFilter from './PortfolioFilter.vue';
export default {
  data: function data() {
    return {
      activeFilter: 0,
      loaded: false,
      filters: [],
      items: []
    };
  },
  components: {
    Item: Item,
    PortfolioFilter: PortfolioFilter
  },
  methods: {
    showItem: function showItem(item) {
      if (this.activeFilter === 0) return true;
      return item.filters.includes(this.activeFilter);
    },
    filterElements: function filterElements(filter) {
      this.activeFilter = filter;
    },
    getItemFilters: function getItemFilters(item) {
      return this.filters.filter(function (f) {
        return item.filters.includes(f.id);
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    // Get filters
    axios.get('/wp-json/wp/v2/filters').then(function (response) {
      _this.filters = response.data;

      _this.filters.map(function (filter) {
        filter.active = false;
      }); // Get initial data


      axios.get('/wp-json/wp/v2/portfolio?per_page=99').then(function (response) {
        _this.items = response.data;
        _this.loaded = true;
      });
    });
  }
};